import { render } from "./UpjangDetail.vue?vue&type=template&id=187120cb"
import script from "./UpjangDetail.vue?vue&type=script&lang=js"
export * from "./UpjangDetail.vue?vue&type=script&lang=js"

import exportComponent from "F:\\stsworkspace\\gil\\yongpyong-mobile-service-main\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__